module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"create-title":"Criar perfil","update-title":"Editar perfil","nav-dependents":"Dependentes","nav-my-profile":"Meu perfil"}}')
  delete Component.options._Ctor
}
